import list from 'src/modules/workType/list/workTypeListReducers';
import form from 'src/modules/workType/form/workTypeFormReducers';
import view from 'src/modules/workType/view/workTypeViewReducers';
import destroy from 'src/modules/workType/destroy/workTypeDestroyReducers';
import importerReducer from 'src/modules/workType/importer/workTypeImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
